<template>
  <div class="workout-tracking-container">
    <div class="container">
      <div class="row motionImgPosition">
        <div class="col-lg-6">
          <div class="workout-img">
            <img :src="imagePath" alt="" />
          </div>
        </div>
        <template v-if='fontPage == "about"'>
          <div class="col-lg-6 ef-section pt-4">
            <div class="section-name">{{sectionName}}</div>
            <div class="section-title-font28">{{sectionTitle}}</div>
            <div class="section-description" v-html="sectionDescription">
            </div>
            <div class="ef-link" v-if="efLink">
              <a @click="scroll(`contact-us`)">{{ efLink }}</a>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-lg-6 ef-section pt-4">
            <div class="section-name">{{sectionName}}</div>
            <div class="section-title">{{sectionTitle}}</div>
            <div class="section-description" v-html="sectionDescription">
            </div>
            <div class="ef-link" v-if="efLink">
              <a @click="scroll(`contact-us`)">{{ efLink }}</a>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
    scroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
  props: {
    sectionName: {
      type: String,
      default: null,
    },
    sectionTitle: {
      type: String,
      default: null,
    },
    sectionDescription: {
      type: String,
      default: null,
    },
    efLink: {
      type: String,
      default: null,
    },
    imagePath: {
      type: String,
      default: null,
    },
    fontPage: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.section-name, .section-description {
  font-size: 20px !important;
  line-height: 30px !important;
}
.section-title{
  font-size: 48px !important;
  line-height: 134.5% !important;
}
.workout-tracking-container {
  background: #f9f9f9;
  padding: 90px 0 90px 0;
}
.workout-img {
  display: flex;
  justify-content: center;
  img {
    border-radius: 25px;
    width: 90%;
    mix-blend-mode: multiply;
  }
}
@media (max-width: 576px) and (orientation: portrait) {
  .workout-tracking-container {
    padding: 8% 2%;
    background: #FFFFFF;
  }
  .motionImgPosition {
    display: flex;
  }
  .workout-img img {
    width: 100%;
    height: unset;
    justify-content: center;
  }
  .section-name, .section-description {
    font-size: 16px !important;
    line-height: 24px !important;
  }
  .section-title{
    font-size: 36px !important;
    line-height: 134.5% !important; 
  }
}
@media (max-width: 992px) and (orientation: landscape) {
  .workout-tracking-container {
    background: #f9f9f9;
    padding: 8% 0;
  }
  .motionImgPosition {
    display: flex;
  }
  .workout-img {
    width: 100%;
    justify-content: center;
  }
  .section-name, .section-description {
    font-size: 16px !important;
    line-height: 24px !important;
  }
  .section-title{
    font-size: 36px !important;
    line-height: 134.5% !important; 
  }
}
</style>
